export var FONT_SIZE = 'T100';